<div id="task-manager" class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container w-p-100">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" iconClass="fas fa-calendar-week"></particle-breadcrumbs>
    </div>
    <div class="flex flex-col justify-end items-start">
      <label class="component-label">View</label>
      <mat-button-toggle-group #group="matButtonToggleGroup" class="view-change-toggle-container m-t-10">
        <mat-button-toggle value="left" (click)="showBoardView()" data-cy="view-board">
          <i class="far fa-columns"></i>
        </mat-button-toggle>
        <mat-button-toggle value="center" (click)="showGridView()" data-cy="view-grid">
          <i class="far fa-th active"></i>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-start items-center">
    <div class="grid-toolbar-buttons-group-container">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button"
                  particleAnalytics
                  analyticsCategory="task-manager-board"
                  analyticsAction="add task"
                  (click)="openTaskManagementDialog(null)" data-cy="Add Task"
          >Add Task
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container m-l-10 flex flex-row justify-start items-center" *ngIf="isSupportTicketGrid">
          <particle-grid-apply-filter [filterId]="sourceKey"
                                      [endpointName]="endpoint"
                                      [invalidateSubject]="invalidateSubject">
          </particle-grid-apply-filter>
          <div class="toolbar-separator m-l-10"></div>
        </div>
        <div class="button-container m-l-10 flex flex-row justify-start items-center">
          <mat-slide-toggle
            data-cy="Show Archived" [(ngModel)]="showArchived"
            (change)="handleChange($event)">
            Show Archived
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <mat-sidenav-container>
    <div class="center">
      <div class="content-card mat-white-bg">
        <div class="content pos-relative m-30">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   sortFieldKey="Name"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
                                   [useSwitchMap]="1===1"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>

</div>





